import Link from 'next/link'
import { cloudFrontUrl, currencyHelper } from '@/lib/utils'
import { DEFAULT_IMAGE } from '@/lib/constant'
import { ImageLoader } from '../ui/image-loader'

interface DestinationCardProps {
    title: string
    price: number | undefined | null
    tours: number
    image: string | null
    href: string
    destination?: string
}

const DestinationCard = ({ price, tours, image, href, destination }: DestinationCardProps) => {
    return (
        <Link href={href} className='h-56 md:h-72 xl:h-96 w-full relative rounded-lg overflow-hidden flex justify-end items-end group select-none'>
            <ImageLoader
                src={image ? cloudFrontUrl(image) : DEFAULT_IMAGE}
                alt='destination img'
                fill
                className='object-cover'
                quality={50}
            />
            <div className='relative h-fit w-full text-white lg:translate-y-4 lg:group-hover:translate-y-0 duration-500 ease-in-out px-2 pb-1 md:p-3 bg-black/35 backdrop-blur-[2.5px]'>
                <div className='flex flex-col gap-1'>
                    <h3 className='text-base lg:text-lg font-lexend font-medium md:font-semibold text-nowrap overflow-hidden text-ellipsis'>
                        {destination}
                    </h3>
                    <span className='h-0.5 w-full lg:w-[3.75rem] bg-white scale-y-[0.6] group-hover:w-full duration-500 ease-out -mt-1' />
                    <div className='text-xs flex flex-col md:flex-row md:items-center flex-nowrap md:gap-2 lg:opacity-0 group-hover:opacity-100 duration-500 transition-all ease-in-out'>
                        <p>
                            {price && price > 0 ? `Starting Price ₹${currencyHelper(price)}/-` : "Price on Request"}
                        </p>
                        <span className='w-0.5 h-3 bg-white scale-x-50 shrink-0 hidden md:block' />
                        <p>
                            {tours} {tours > 1 ? "Tours" : "Tour"}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default DestinationCard